/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  width: 100%;
  --cursor: pointer;
}

[internal-host] {
  cursor: var(--cursor);
  color: var(--color);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: var(--nve-ref-space-xs);
}

slot:not([name]) {
  display: block;
  flex: 1;
}
